
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-all-funeral/[parlor]/[crema]/[facility]",
      function () {
        return require("private-next-pages/gangwon-all-funeral/[parlor]/[crema]/[facility].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-all-funeral/[parlor]/[crema]/[facility]"])
      });
    }
  